import { configureStore } from "@reduxjs/toolkit";
import reportResultSlice from "./reports/reportResultSlice";
import reportViewerSlice from "./reports/reportViewerSlice";
import allReportListSlice from "./reports/builder/allReportListSlice";
import patientInfoSlice from "./patient/patientInfoSlice";
import patientBillingSlice from "./patient/PatientBillingInfo/patientBillingSlice";
import statementManagementSlice from "../components/patientManagement/StatementManagement/StatementManagmentRedux/statementManagementSlice";
import OpenArReportSlice from "../components/reports/OpenARReport/openArSlice";
import CheckLevelReportSlice  from "../components/reports/CheckLevelReport/CheckLevelReportSlice";
import reportSlice from "../components/reports/ReportFilter/reportFilterSlice";
import reportStatusManagerSlice from "../components/reports/reportStatusManagerSlice"
import commonStateSlice from "./CommonStateSlice";
import patientAdvanceSearchSlice from "./patient/PatientAdvanceSearch/PatientAdvanceSearchSlice";
import BatchEligibilitySlice from "../components/patientManagement/RunEligibility/BatchEligibilitySlice";
import taskSlice from "../components/MyTasksScreen/TaskSlice/taskSlice";
import importBatchSlice from "../components/patientManagement/RunEligibility/importBatchSlice";
import claimManagementSlice from "../components/ClaimModule/StateManagement/ClaimModuleSlice"
import DropDownOptionSlice from "../components/ClaimModule/StateManagement/DropDownOptionSlice";
import paymentSlice from "../components/Payments/PaymentModule/StateManagement/paymentSlice"
import eraSlice from '../components/Payments/ERAModule/StateManagement/eraSlice';
import DenialReportSlice from "../components/reports/DenialReport/DenialReportSlice";
import reportGeneratorSlice from "../components/reports/ReportGenerator/StateManagment/reportGeneratorSlice";
import printConfigSlice from '../components/PrintConfig/printConfigSlice';
import notificationSlice from '../components/Notifications/statemanagement/notificationSlice';
import workflowManagementSlice from '../components/Workflow/StateManagement/WorkflowManagementSlice';
import claimbetaSlice from '../components/ClaimBeta/Claim/StateManagement/ClaimBetaSlice'
import patientBetaSlice from '../components/ClaimBeta/Patient/StateManagement/PatientModuleSlice';
import myworkSlice from '../components/ClaimBeta/MyWork/StateManagement/MyWorkSlice';   
import eraAutomationSlice from '../components/AutomationConfig/ERAAutomationConfig/eraAutomationSlice';
import autoEVSlice from '../components/AutomationConfig/AutoEVAutomationConfig/autoEVSlice';

/**
 * reportViewer, reportResult & allReports are not in use, this may need in future when implementing dynamic report generation!
 */

export const store = configureStore({
  reducer: {
    commonStates: commonStateSlice,
    reportViewer: reportViewerSlice,
    reportResult: reportResultSlice,
    allReports: allReportListSlice,
    patientData: patientInfoSlice,
    otherBillingData: patientBillingSlice,
    statementMgData: statementManagementSlice,
    openArReport: OpenArReportSlice,
    checkLevelReport: CheckLevelReportSlice,
    filterDropdownData: reportSlice,
    mainReportStatus: reportStatusManagerSlice,
    patientAdvanceSearchData: patientAdvanceSearchSlice,
    batchEligibilityTab2: BatchEligibilitySlice,
    taskData: taskSlice,
    importBatch: importBatchSlice,
    claimManagement: claimManagementSlice,
    claimSelectInputManager: DropDownOptionSlice,
    paymentData: paymentSlice,
    ERAData:eraSlice,
    denialReport: DenialReportSlice,
    printConfig: printConfigSlice,
    ReportGeneratorData: reportGeneratorSlice,
    notificationData:notificationSlice,
    workflow:workflowManagementSlice,
    claimbeta: claimbetaSlice,
    patientbeta:patientBetaSlice,
    mywork: myworkSlice,
    eraAutomation: eraAutomationSlice,
    autoEVAutomation: autoEVSlice
  },
  devTools: {
   stateSanitizer: (state) => state.notificationData 
      ? { ...state, notificationData: '<< HIDDEN >>' } 
      : state,
    actionsDenylist: ['^notifications/.*'],
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(), //MIDDLEWARE TO LOG ACTIONS AND VALUES
});
